import { usePartialState } from '@tencent/dz-models';
import { usePageModel } from '@tencent/dz-runtime';
export function useMessageById(messageId) {
    var model = usePageModel();
    var _a = usePartialState(function () { return model.getMessageModel(); }), messageModel = _a[1];
    var messageState = messageModel.getMessageById(messageId);
    if (!messageState) {
        console.error(messageId + " \u4E0D\u5B58\u5728\uFF0C\u8BF7\u6392\u67E5\u5F02\u5E38\u60C5\u51B5");
        throw new Error("messageId: " + messageId + "\u4E0D\u5B58\u5728\uFF0C\u8BF7\u6392\u67E5\u5F02\u5E38\u60C5\u51B5");
    }
    return messageState;
}
export function useMessageModel() {
    var model = usePageModel();
    var _a = usePartialState(function () { return model.getMessageModel(); }), messageModel = _a[1];
    return messageModel;
}
